import { Route, Routes } from "react-router-dom";
import { C_PATH_ROUTER, C_PATH_ROUTES } from "../../shared/model/const/path.const";
import RealestateDetailPage from "../realestate/pages/realestate-detail/RealestateDetailPage";
import PropertyListPage from "./pages/list/PropertyListPage";
import PropertyDetailPage from "./pages/detail/PropertyDetailPage";
import Page404 from "@rf-l3/pages/404";
import PropertyDraftListPage from "./pages/draft-list/PropertyDraftListPage";
import ReadOnlyRouteGuard from "@rf-l3/routes/ReadOnlyRouteGuard";

function PropertyRouterModule() {
  return (
    <Routes>
      <Route
        path={C_PATH_ROUTER.PROPERTIES.DRAFT_LIST}
        element={<PropertyDraftListPage />}
      />
      <Route
        path={C_PATH_ROUTER.PROPERTIES.DRAFT_UPDATE}
        element={<ReadOnlyRouteGuard redirectTo={C_PATH_ROUTES.REALESTATE.LIST} />}
      />
      <Route
        path={C_PATH_ROUTER.PROPERTIES.DRAFT_PROJECT_UPDATE}
        element={<ReadOnlyRouteGuard redirectTo={C_PATH_ROUTES.REALESTATE.LIST} />}
      />

      {/* <Route
        path={C_PATH_ROUTER.PROPERTIES.DETAIL}
        element={<RealestateDetailPage />}
      /> */}
      <Route
        path={C_PATH_ROUTER.PROPERTIES.DETAIL_SHORT}
        element={<RealestateDetailPage />}
      />
      <Route
        path={C_PATH_ROUTER.PROPERTIES.CREATE}
        element={<ReadOnlyRouteGuard redirectTo={C_PATH_ROUTES.REALESTATE.LIST} />}
      />
      <Route
        path={C_PATH_ROUTER.PROPERTIES.UPDATE}
        element={<ReadOnlyRouteGuard redirectTo={C_PATH_ROUTES.REALESTATE.LIST} />}
      />
      <Route
        path={C_PATH_ROUTER.PROPERTIES.PROJECT_CREATE}
        element={<ReadOnlyRouteGuard redirectTo={C_PATH_ROUTES.REALESTATE.LIST} />}
      />
      <Route
        path={C_PATH_ROUTER.PROPERTIES.PROJECT_UPDATE}
        element={<ReadOnlyRouteGuard redirectTo={C_PATH_ROUTES.REALESTATE.LIST} />}
      />
      <Route
        path={C_PATH_ROUTER.REALESTATE.RESOLVE_CONFLICT}
        element={<ReadOnlyRouteGuard redirectTo={C_PATH_ROUTES.REALESTATE.LIST} />}
      />
      <Route
        path={C_PATH_ROUTER.PROPERTIES.DETAIL}
        element={<PropertyDetailPage />}
      />

      <Route path={C_PATH_ROUTER.PROPERTIES.LIST} element={<PropertyListPage />} />

      <Route
        path="*"
        element={
          <Page404
            path={C_PATH_ROUTER.PROPERTIES.LIST}
            title="URL no válida"
            buttonMessage="Volver a la lista de propiedades"
          />
        }
      />
    </Routes>
  );
}

export default PropertyRouterModule;
